import socialMediaData from '@/data/socialMedia.json';
import type { SocialMediaSection } from '@/data/types';

export function useSocialMediaData() {
  return { 
    socialMediaData: socialMediaData as SocialMediaSection 
  };
}